/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SendMessageToThreadRequestMessagesInner } from './SendMessageToThreadRequestMessagesInner';
import {
    SendMessageToThreadRequestMessagesInnerFromJSON,
    SendMessageToThreadRequestMessagesInnerFromJSONTyped,
    SendMessageToThreadRequestMessagesInnerToJSON,
    SendMessageToThreadRequestMessagesInnerToJSONTyped,
} from './SendMessageToThreadRequestMessagesInner';

/**
 * 
 * @export
 * @interface SendMessageToThreadRequest
 */
export interface SendMessageToThreadRequest {
    /**
     * Array of messages in the conversation
     * @type {Array<SendMessageToThreadRequestMessagesInner>}
     * @memberof SendMessageToThreadRequest
     */
    messages: Array<SendMessageToThreadRequestMessagesInner>;
    /**
     * Optional user ID for the conversation
     * @type {string}
     * @memberof SendMessageToThreadRequest
     */
    userId?: string;
}

/**
 * Check if a given object implements the SendMessageToThreadRequest interface.
 */
export function instanceOfSendMessageToThreadRequest(value: object): value is SendMessageToThreadRequest {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function SendMessageToThreadRequestFromJSON(json: any): SendMessageToThreadRequest {
    return SendMessageToThreadRequestFromJSONTyped(json, false);
}

export function SendMessageToThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageToThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(SendMessageToThreadRequestMessagesInnerFromJSON)),
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

  export function SendMessageToThreadRequestToJSON(json: any): SendMessageToThreadRequest {
      return SendMessageToThreadRequestToJSONTyped(json, false);
  }

  export function SendMessageToThreadRequestToJSONTyped(value?: SendMessageToThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(SendMessageToThreadRequestMessagesInnerToJSON)),
        'userId': value['userId'],
    };
}

